import AboutView from './About.view';
export * from './About.view';

export const About = (props) => AboutView(props);

export default About;

